import { render } from "./PolicyModalPage.vue?vue&type=template&id=eaeaa45e"
import script from "./PolicyModalPage.vue?vue&type=script&lang=js"
export * from "./PolicyModalPage.vue?vue&type=script&lang=js"

import "./PolicyModalPage.vue?vue&type=style&index=0&id=eaeaa45e&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__